export default __webpack_public_path__ + "static/media/banner1.0daa22e1.jpg";